module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('h1', {
    staticClass: "pageTitle"
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.productGroups.edit.title')))])])], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('br'), _c('br')]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "whiteWrapper"
  }, [_c('el-tabs', {
    attrs: {
      "value": "1"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.productGroups.formTabs.groupInformation'),
      "name": "1"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.productGroups",
      "hasLabel": true
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'productGroups.index'
      }
    }
  }, [_c('el-button', {
    staticClass: "dark"
  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "outline",
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa5a90a4","hasScoped":false}!./src/app/pages/withNavigation/productGroups/edit/edit.html
// module id = 3141
// module chunks = 1